export default "__VITE_ASSET__6b70fbbc__"